import OpenRequestsInbox from './OpenRequestsInbox';

const Inbox = () => (
  <OpenRequestsInbox
    title="User Inbox"
    subtitle="Open DCR requests pending user review"
  />
);

export default Inbox;
